const navSlide = () => {
  $('.burger').on('click', function () {
    $('.mobile-nav').toggleClass('active');
    $(this).toggleClass('active');
    $('body').toggleClass('disabled');
    // $('.nav-link').toggleClass('active');
  });
};

function searchbox() {
  $('.searchbox-icon').on('click', function () {
    $('.search-wrapper').toggleClass('active');
    $('.nav-right .nav-list').toggleClass('disable');
    $('.nav-right .callme ').toggleClass('disable');
    $('.nav-right .searchbox-icon').toggleClass('disable');
    $('.nav-right .language').toggleClass('disable');
    $('nav#mobile .tool-items').toggleClass('disable');
  });
  $('.delete-search').on('click', function () {
    $('.search-wrapper').removeClass('active');
    $('.nav-right .nav-list').removeClass('disable');
    $('.nav-right .callme ').removeClass('disable');
    $('.nav-right .searchbox-icon').removeClass('disable');
    $('nav#mobile .tool-items').removeClass('disable');
    $('.nav-right .language').removeClass('disable');
  });
  $('main').on('click', function () {
    $('.search-wrapper').removeClass('active');
    $('.nav-right .nav-list').removeClass('disable');
    $('.nav-right .callme ').removeClass('disable');
    $('.nav-right .searchbox-icon').removeClass('disable');
    $('.nav-right .language').removeClass('disable');
    $('nav#mobile .tool-items').removeClass('disable');
    $('.nav-right .language').removeClass('disable');
  });
}

function contact_mtt() {
  $('.box-contact .wrapper .btn-detail').on('click', function () {
    $('.box-contact .wrapper ').toggleClass('active');
    $('.box-contact .form-section ').toggleClass('active');
  });
}

function sticky_mtt() {
  $('.mtt_nav').sticky({
    topSpacing: $('header').outerHeight(),
    zIndex: 999,
  });
}

function scrollActive() {
  $(window)
    .scroll(function () {
      var heightTop =
        $('header').outerHeight() + $('#page-banner').outerHeight();
      var scrollDistance = $(window).scrollTop() - heightTop;

      // Show/hide menu on scroll
      //if (scrollDistance >= 850) {
      //		$('nav').fadeIn("fast");
      //} else {
      //		$('nav').fadeOut("fast");
      //}

      // Assign active class to nav links while scolling
      $('.mtt').each(function (i) {
        if ($(this).position().top <= scrollDistance) {
          $('#mtt_scroll li.active-2').removeClass('active-2');
          $('#mtt_scroll li').eq(i).addClass('active-2');
        }
      });
    })
    .scroll();
}

function autoactive_mtt() {
  var mtt_wrapper = $('.mtt_wrapper');
  var mtt_li = $('.mtt_wrapper li');
  for (var i = 0; i < mtt_li.length; i++) {
    mtt_li[i].addEventListener('click', function () {
      var current = $('.active-2');
      current[0].className = current[0].className.replace('active-2', '');
      this.className += 'active-2';
    });
  }
}
// Add smooth scrolling to all links
function scrollToDiv() {
  $('#mtt_scroll a').on('click', function (event) {
    if (this.hash !== '') {
      event.preventDefault();
      var hash = this.hash;
      $('html, body').animate({
        scrollTop: $(hash).offset().top - $('header').outerHeight() - 50,
      });
    }
  });
}

//Header when scroll
const activeHeaderWhenScroll = () => {
  window.addEventListener('scroll', function () {
    if (window.pageYOffset > 0 && $(window).width() >= 1200) {
      document.querySelector('header').classList.add('header-scroll');
      $('header').find('.logo').addClass('active');
      $('header').find('.logo-scroll').addClass('active');
    } else {
      document.querySelector('header').classList.remove('header-scroll');
      $('header').find('.logo').removeClass('active');
      $('header').find('.logo-scroll').removeClass('active');
    }
  });
};
const hover_product = () => {
  $('a.btn.btn-detail').hover(
    function () {
      $(this).siblings('.title').find('a').css('color', '#00a651');
    },
    function () {
      $(this).siblings('.title').find('a').css('color', '#333333');
    }
  );
};
// Collapse Solution List
const collapse = () => {
  $('.collapse-body-item .title').click(function () {
    $(this).addClass('active');
    $(this).siblings('.content').slideDown();
  });
  $('.collapse-body-item .title')
    .not(this)
    .parent('.collapse-body-item')
    .find('.content')
    .slideUp();
  // $('.collapse-header').click(function() {
  //     var title = $(this);
  //     var parent = title.parent('.collapse-items');
  //     var list = title.siblings('.collapse-body');
  //     if (parent.hasClass('is-open')) {
  //         list.slideUp('slow');
  //         parent.removeClass('is-open');
  //     } else {
  //         list.slideDown('slow');
  //         parent.addClass('is-open');
  //     }
  // });
};
//Slide banner
function CrMainBanner() {
  var swiper = new Swiper('.banner-wrapper .swiper-container', {
    loop: true,
    speed: 1000,
    grabCursor: true,
    watchSlidesProgress: true,
    mousewheelControl: true,
    keyboardControl: true,
    effect: 'fade',
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
  });
  // Introduce
  var introduce_i3 = new Swiper('.introduce_i-3-slider .swiper-container', {
    loop: true,
    clickable: true,
    watchSlidesProgress: true,
    mousewheelControl: true,
    keyboardControl: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      480: {
        slidesPerView: 4,
        spaceBetween: 40,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 40,
      },
      991: {
        slidesPerView: 5,
        spaceBetween: 50,
      },
      1200: {
        slidesPerView: 6,
        spaceBetween: 60,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  var introduce_i4 = new Swiper('.introduce_i-4-slider .swiper-container', {
    loop: true,
    grabCursor: true,
    watchSlidesProgress: true,
    mousewheelControl: true,
    keyboardControl: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    breakpoints: {
      375: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      567: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      769: {
        slidesPerView: 3,
        spaceBetween: 4,
      },
    },
    navigation: {
      nextEl: '.introduce_i-4-slider.swiper-button-next',
      prevEl: '.introduce_i-4-slider.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
  // Project Detail
  var project_detail_1 = new Swiper('.project-detail-slide .swiper-container', {
    loop: true,

    grabCursor: true,
    watchSlidesProgress: true,
    mousewheelControl: true,
    keyboardControl: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    breakpoints: {
      480: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      567: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
    navigation: {
      nextEl: '.project-detail-slide .swiper-button-next',
      prevEl: '.project-detail-slide .swiper-button-prev',
    },
  });
  var project_detail_2 = new Swiper(
    '.project-detail-slide-2 .swiper-container',
    {
      loop: true,
      grabCursor: true,
      watchSlidesProgress: true,
      mousewheelControl: true,
      keyboardControl: true,
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        767: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
      },
      navigation: {
        nextEl: '.project-detail-slide-2 .swiper-button-next',
        prevEl: '.project-detail-slide-2 .swiper-button-prev',
      },
    }
  );
  //Index slide
  var index_2 = new Swiper('.index-2-slide .swiper-container', {
    loop: true,
    grabCursor: true,
    watchSlidesProgress: true,
    mousewheelControl: true,
    keyboardControl: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    breakpoints: {
      991: {
        slidesPerView: 1,
      },
      1200: {
        slidesPerView: 2,
        slidesPerGroup: 1,
        spaceBetween: 10,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  var index_4 = new Swiper('.index-4-slide .swiper-container', {
    grabCursor: true,

    watchSlidesProgress: true,
    mousewheelControl: true,
    keyboardControl: true,
    speed: 500,
    autoplay: {
      delay: 3500,
      disableOnInteraction: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 30,
        slidesPerColumn: 2,
        slidesPerColumnFill: 'row',
        slidesPerGroup: 2,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  // MTT Clinic
  var mtt_2 = new Swiper('.mtt-2-slide .swiper-container', {
    loop: true,

    grabCursor: true,
    watchSlidesProgress: true,
    mousewheelControl: true,
    keyboardControl: true,
    spaceBetween: 30,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      1024: {
        slidesPerView: 2,
      },
    },
    navigation: {
      nextEl: '.mtt-2-slide .swiper-button-next',
      prevEl: '.mtt-2-slide .swiper-button-prev',
    },
  });
  var mtt_3 = new Swiper('.mtt-3-slide .swiper-container', {
    loop: true,
    grabCursor: true,
    watchSlidesProgress: true,
    mousewheelControl: true,
    keyboardControl: true,
    spaceBetween: 30,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      1024: {
        slidesPerView: 3,
      },
    },
    navigation: {
      nextEl: '.mtt-3-slide .swiper-button-next',
      prevEl: '.mtt-3-slide .swiper-button-prev',
    },
  });
  var mtt_4 = new Swiper('.mtt-4-slide .mtt-4-1', {
    breakpoints: {
      576: {
        slidesPerView: 1,
        slidesPerColumn: 1,
      },
      768: {
        slidesPerView: 1,
        slidesPerGroup: 2,
        spaceBetween: 15,
        slidesPerColumn: 2,
        slidesPerColumnFill: 'row',
      },
      1024: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 30,
        slidesPerColumn: 2,
        slidesPerColumnFill: 'row',
      },
      1200: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 30,
        slidesPerColumn: 2,
        slidesPerColumnFill: 'row',
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  var solu_detail_thumbs = new Swiper('.solu-detail-thumbs', {
    loop: true,
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    grabCursor: true,
    watchSlidesProgress: true,
    mousewheelControl: true,
    keyboardControl: true,
    spaceBetween: 10,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });
  var solu_detail_top = new Swiper('.solu-detail-top ', {
    spaceBetween: 0,
    grabCursor: true,
    watchSlidesProgress: true,
    mousewheelControl: true,
    keyboardControl: true,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: solu_detail_thumbs,
    },
  });
  var check = $('.other-product-slide .swiper-slide');
  let checkvalue;
  if ($(check).length > 1) {
    checkvalue = false;
  } else {
    checkvalue = true;
  }
  var solu_other_product = new Swiper(
    '.other-product-slide .swiper-container',
    {
      loop: true,
      grabCursor: true,
      watchSlidesProgress: true,
      mousewheelControl: true,
      keyboardControl: true,
      centeredSlides: checkvalue,
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
      navigation: {
        nextEl: '.other-product-slide .swiper-button-next',
        prevEl: '.other-product-slide .swiper-button-prev',
      },
    }
  );
  var solu_other = new Swiper('.solu-other-slide .swiper-container', {
    loop: true,
    grabCursor: true,
    watchSlidesProgress: true,
    mousewheelControl: true,
    keyboardControl: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
    navigation: {
      nextEl: '.solu-other-slide .swiper-button-next',
      prevEl: '.solu-other-slide .swiper-button-prev',
    },
    //Service
  });
  var service_detail_2 = new Swiper(
    '.service-detail-slide-2 .swiper-container',
    {
      loop: true,
      grabCursor: true,
      watchSlidesProgress: true,
      mousewheelControl: true,
      keyboardControl: true,
      // autoplay: {
      //     delay: 3500,
      //     disableOnInteraction: false,
      // },
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
      navigation: {
        nextEl: '.service-detail-slide-2 .swiper-button-next',
        prevEl: '.service-detail-slide-2 .swiper-button-prev',
      },
    }
  );
}
//Check banner
const checkLayoutBanner = () => {
  const pagesBanner = $('#page-banner');
  const heightHeader = $('header').outerHeight();
  const mainBanner = $('#home-banner');
  if (mainBanner.length >= 1) {
    $('main').css('padding-top', heightHeader);
  } else if (pagesBanner.length >= 1) {
    $('main').css('padding-top', heightHeader);
  } else {
    $('main').css('padding-top', heightHeader);
  }
};

function checkbrand() {
  if ($('#page-banner .banner-wrapper .bg-blue .content .title').text() == '') {
    $('#page-banner .banner-wrapper .bg-blue .content .title').css(
      'display',
      'none'
    );
  } else if (
    $('#page-banner .banner-wrapper .bg-blue .content .brand').length < 1
  ) {
    $('#page-banner .banner-wrapper .bg-blue .content .title').css(
      'margin',
      '0'
    );
  }
}
checkbrand();
// Trang tuyển dụng
jQuery(document).ready(function ($) {
  var alterClass = function () {
    var ww = document.body.clientWidth;
    if (ww < 1200) {
      $('.tuyendung-col').removeClass('pr-0');
    } else if (ww >= 1200) {
      $('.tuyendung-col').addClass('pr-0');
    }
  };
  $(window).resize(function () {
    alterClass();
  });
  alterClass();
});

jQuery(document).ready(function ($) {
  var alterClass = function () {
    var ww = document.body.clientWidth;
    if (ww < 1200) {
      $('.tuyendung-col-2').removeClass('pl-0');
    } else if (ww >= 1200) {
      $('.tuyendung-col-2').addClass('pl-0');
    }
  };
  $(window).resize(function () {
    alterClass();
  });
  alterClass();
});

function showBackToTop() {
  var heightTop = $('header').outerHeight() + $('#home-banner').outerHeight();
  var heightPageTop =
    $('header').outerHeight() + $('#page-banner').outerHeight();
  $(window).scroll(function () {
    if (
      $(this).scrollTop() > heightTop ||
      $(this).scrollTop() > heightPageTop
    ) {
      $('#back-to-top').addClass('active');
    } else {
      $('#back-to-top').removeClass('active');
    }
  });

  $('#back-to-top').on('click', function (e) {
    e.preventDefault();
    $('html,body').animate({
      scrollTop: 0,
    });
  });
}

const checkbcrumbintroduce = () => {
  // const pagesintro = $('.pages-introduce');
  const pagesintro = $('.Module.Module-243');
  const pagesProDetail = $('.pages-project-detail');
  const breadcrumb = $('.global-breadcrumb');
  if (pagesintro.length == 1) {
    breadcrumb.css('background-color', '#ffffff');
  } else if (pagesProDetail.length == 1) {
    breadcrumb.css('height', 'auto');
  }
};

function initMapping() {
  $('header #desktop .main-nav .nav-right .tool-items').mapping({
    mobileWrapper: 'header #mobile',
    mobileMethod: 'appendTo',
    desktopWrapper: 'header #desktop .main-nav .nav-right',
    desktopMethod: 'appendTo',
    breakpoint: 1200,
  });
}

function headerMapping() {
  $('header #desktop .main-nav .nav-left ul.nav-list li.nav-item').mapping({
    mobileWrapper: 'header .mobile-nav ul.mobile-list',
    mobileMethod: 'appendTo',
    desktopWrapper: 'header #desktop .main-nav .nav-left ul.nav-list',
    desktopMethod: 'appendTo',
    breakpoint: 1200,
  });
  $('header #desktop .main-nav .nav-right ul.nav-list li.nav-item').mapping({
    mobileWrapper: 'header .mobile-nav ul.mobile-list',
    mobileMethod: 'appendTo',
    desktopWrapper: 'header #desktop .main-nav .nav-right ul.nav-list',
    desktopMethod: 'appendTo',
    breakpoint: 1200,
  });
}

function activeMobileMenu() {
  // $(window).resize(function() {
  $('.nav-item').on('click', function (z) {
    if ($(window).width() <= 1200) {
      z.stopPropagation();
      $(z.currentTarget).children('.nav-child').slideToggle();
    }
  });
  $('.nav-child-item').on('click', function (z) {
    if ($(window).width() <= 1200) {
      z.stopPropagation();
      $(z.currentTarget).children('.nav-child-inner').slideToggle();
    }
  });
  $('.nav-item span').on('click', function () {
    if ($(window).width() <= 1200) {
      $(this).parent('.nav-item-wrapper').toggleClass('active');
    }
  });

  $('.nav-child-item').on('click', function () {
    if ($(window).width() <= 1200) {
      $(this).toggleClass('active');
    }
  });
  // });
}

function MultiLevelAccordiion() {
  $('.accordion__title .material-icons').click(function (e) {
    e.preventDefault();
    var t = $(this);
    var title = $('.accordion__title');
    if (t.closest('li').closest('li').is('.acitve')) {
      t.closest('li').removeClass('active');
      t.closest('li').find('> ul.inner').slideUp();
      t.closest('li').siblings().removeClass('active');
      t.closest('li').siblings().find('ul').slideUp();
    } else if (t.closest('li').closest('li').not('.acitve')) {
      t.closest('li').addClass('active');
      t.closest('li').find('> ul.inner').slideDown();
      t.closest('li').siblings().removeClass('active');
      t.closest('li').siblings().find('ul').slideUp();
    } else if (t.closest('li').is('.active')) {
      t.closest('li').removeClass('active');
      t.closest('li').find('> ul.inner').slideUp();
      title.find('ul.inner').slideUp();
    } else {
      title.removeClass('active');
      title.find('ul.inner').slideUp();
      t.closest('li').find('> ul.inner').slideDown();
      t.closest('li').addClass('active');
    }
  });
}

function phantrang() {
  $('.modulepager')
    .find('.pagination')
    .find('li>a.NextPage, li>a.LastPage, li>a.BackPage, li>a.FirstPage')
    .parent()
    .hide();
}

function moveForm() {
  if ($('.pages-service-detail, .pages-solution-detail').length >= 1) {
    $('#form-wrapper').css('display', 'block');
    $('#form-wrapper').appendTo('#form-inner');
  } else {
    $('#form-wrapper').css('display', 'none');
  }
}
function changePlaceholder() {
  $('.subscribe .subscribefrm button ').text('Liên hệ');
}
function modal_doitac() {
  var index = $('section.index-7');
  var introduce = $('section.introduce-i-3');
  if (index.length == 1) {
    $('.index-7 .modal .col-xl-10')
      .addClass('col-xl-12')
      .removeClass('col-xl-10');
  }
  if (introduce.length == 1) {
    $('.introduce-i-3 .modal .col-xl-10')
      .addClass('col-xl-12')
      .removeClass('col-xl-10');
  }
}
document.addEventListener('DOMContentLoaded', () => {
  modal_doitac();
  initMapping();
  navSlide();
  activeHeaderWhenScroll();
  CrMainBanner();
  checkLayoutBanner();
  searchbox();
  showBackToTop();
  checkbcrumbintroduce();
  // contact_mtt();
  sticky_mtt();
  autoactive_mtt();
  collapse();
  hover_product();
  scrollToDiv();
  MultiLevelAccordiion();
  headerMapping();
  activeMobileMenu();
  phantrang();
  moveForm();
  changePlaceholder();
});
